class ConfiguratorAppointmentLocation extends HTMLElement {
    constructor() {
      super();
  
      this.drawer = document.querySelector('configurator-drawer');
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.possibleNextSteps = ['appointment-calendar'];
      this.nextStepsHtml = {};
      this.previousStepHtml = undefined;
      this.getNextSteps();
      this.getPreviousSteps();
  
      if (this.drawer.appointment.q) this.proceed(this.drawer.appointment.q);
    }
  
    getFormValue() {
      const formData = new FormData(this.form);
      return [...formData.entries()];
    }
  
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
  
      const formData = new FormData(this.form);
  
      this.renderNextStep('quality');
    }
  
    getLocations(q) {
      if (!q) return;
  
      return [
        {
          name: 'Optik Lotz GmbH',
          street: 'Große Marktstraße 16',
          zip: '63065',
          city: 'Offenbach am Main',
          distance: 5.5,
        },
        {
          name: 'GUCK - Optik',
          street: 'Bieberer Straße 18',
          zip: '63065',
          city: 'Offenbach am Main',
          distance: 5.7,
        },
        {
          name: 'Jung Optik',
          street: 'Kaiserstraße 63',
          zip: '63065',
          city: 'Offenbach am Main',
          distance: 6.2,
        },
        {
          name: 'Oliver Münning',
          street: 'Offenbacher Landstraße 315',
          zip: '60599',
          city: 'Frankfurt am Main',
          distance: 9.2,
        },
        {
          name: 'Art-Optik Batschari',
          street: 'Berger Straße 62',
          zip: '60316',
          city: 'Frankfurt am Main',
          distance: 9.7,
        },
        {
          name: 'Friedauer Optik',
          street: 'Berger Straße 189',
          zip: '60385',
          city: 'Frankfurt am Main',
          distance: 10.1,
        },
      ];
    }
  
    createElement(type, content = '', cssClass = false) {
      const element = document.createElement(type);
      if (cssClass) element.classList.add(cssClass);
      element.textContent = content;
      return element;
    }
  
    renderLocations(q) {
      const locations = this.getLocations(q);
  
      if (!locations) return;
  
      locations.forEach((location) => {
        const locationElement = this.generateLocationElement(location);
        const locationJsonString = JSON.stringify(location);
        locationElement.dataset.locationInfo = locationJsonString;
  
        this.form.appendChild(locationElement);
  
        locationElement.addEventListener('click', () => this.onLocationClickHandler(locationElement));
      });
    }
  
    onSearchLocationHandler() {
      // clear first
      this.form.querySelectorAll('.drawer__form_option').forEach((location) => location.remove());
  
      const q = document.querySelector('.appointment_search input').value;
  
      this.renderLocations(q);
      this.drawer.appointment.q = q;
    }
  
    proceed(q) {
      document.querySelector('.appointment_search input').value = q;
      document.querySelector('.appointment_search button').click();
    }
  
    onLocationClickHandler(locationElement) {
      const locationInfoJson = JSON.parse(locationElement.dataset.locationInfo);
      this.drawer.appointment.location = locationInfoJson;
  
      this.renderNextStep('appointment-calendar');
    }
  
    generateLocationElement(location) {
      const locationSvg = document.querySelector('.appointment_search .my_location svg');
      const distanceValue = `${location.distance.toLocaleString('de-DE', { minimumFractionDigits: 1 })} km`;
  
      const locationWrapper = this.createElement('div', '', 'drawer__form_option');
      const leftContainer = this.createElement('div', '', 'location_info');
      const rightContainer = this.createElement('div', '', 'location_position');
      const locationName = this.createElement('b', location.name, 'location_name');
      const locationStreet = this.createElement('span', location.street, 'location_street');
      const locationZip = this.createElement('span', location.zip, 'location_zip');
      const locationCity = this.createElement('span', location.city, 'location_city');
      const locationDistance = this.createElement('span', distanceValue, 'location_distance');
      const locationOrt = this.createElement('span');
  
      locationOrt.appendChild(locationZip);
      locationOrt.appendChild(locationCity);
  
      leftContainer.appendChild(locationName);
      leftContainer.appendChild(locationStreet);
      leftContainer.appendChild(locationOrt);
  
      rightContainer.appendChild(locationSvg.cloneNode(true));
      rightContainer.appendChild(locationDistance);
  
      locationWrapper.appendChild(leftContainer);
      locationWrapper.appendChild(rightContainer);
  
      return locationWrapper;
    }
  
    getNextSteps() {
      const sections = [];
      this.possibleNextSteps.forEach((step) => sections.push('configurator-' + step));
      const url = '?sections=' + sections.join(',');
  
      fetch(url)
        .then((response) => response.json())
        .then((response) => {
          this.possibleNextSteps.forEach((step) => {
            this.nextStepsHtml[step] = response[`configurator-${step}`];
          });
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    getPreviousSteps() {
      fetch('?sections=configurator-acuity')
        .then((response) => response.json())
        .then((response) => {
          this.previousStepHtml = response['configurator-acuity'];
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    renderPreviousStep() {
      if (!this.previousStepHtml) return;
  
      this.drawer.renderContents(this.previousStepHtml);
    }
  
    renderNextStep(nextStep) {
      this.drawer.renderContents(this.nextStepsHtml[nextStep]);
    }
  }
  
  customElements.define('configurator-appointment-location', ConfiguratorAppointmentLocation);
  